import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WalletRoutingModule } from './wallet-routing.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';

import { CarteraComponent } from './cartera/cartera.component';
import { AbonoCarteraComponent } from './abono-cartera/abono-cartera.component';
import { ToastModule } from 'primeng/toast';
import { AccordionModule } from 'primeng/accordion';
import { DividerModule } from 'primeng/divider';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ResourcesModule } from '../resources/resources.module';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';



@NgModule({
  declarations: [CarteraComponent, AbonoCarteraComponent],
  imports: [
    CommonModule,
    WalletRoutingModule,
    ResourcesModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    ButtonModule,
    InputTextModule,
    InputNumberModule,
    ToastModule,
    AccordionModule,
    DividerModule,
    AutoCompleteModule,
    DialogModule
  ]
})
export class WalletModule { }
